<script>
export default {
    name: "CashReceipt",

    data() {

        return {
            items: [],
            patient: {},
            footerMessage: {},
        };
    },

    computed: {

        total() {

            if(!this.items.receiptdetails.length) return 0;

            return this.items.receiptdetails.map(item => item.paid ? parseFloat(item.paid) : 0)
                .reduce((sum, amt) => sum +amt);
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ 
                this.fetchReceiptItems(), this.fetchPatient(), this.fetchMessage(),
            ]).then(() => {
                this.$root.loading=false;
                setTimeout(() => {
                    window.print();
                }, 250);
            }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchReceiptItems() {
            //let url = `Accounts/GetReceiptDetails`;
            let url = `Accounts/GetReceiptWConsumablesDetails`;
                url += `?ReceiptNo=${this.$route.params.receiptNo}`

            return this.$http.get(url).then(response => {
                this.items = response.data;
            }).catch(() => {});
        },

        fetchMessage() {
          let url = `MasterData/GetSpecificOrganizationMessageforGroup`;
          url += `?Group=Cash Receipt`;

          return this.$http.get(url).then(({ data }) => {
            this.footerMessage = data.length ? data[0] : {};
          });
        },
    },
}
</script>
<template>
<div class="flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="flex-1 my-1 text-center p-1">
        <h5 class="font-bold">CASH RECEIPT</h5> 
    </div>
    <div class="flex flex-wrap w-full mt-1 border-t-2 border-gray-400 px-1">
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">Name: {{ patient.names}}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">VisitNO: {{ patient.visitNo }}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">Date: 
                {{ items.receiptdetails.length ? $root.formatDate(items.receiptdetails[0].date) : `-` }}</h5>
        </div>
        <div class="w-full my-1">
            <h5 class="font-medium text-sm">P Mode: 
                {{ items.receiptdetails.length ? items.receiptdetails[0].mode : `-` }}</h5>
        </div>
    </div>
    <div class="w-full text-center my-1">
        <h5 class="font-bold uppercase text-base">Receipt NO: {{ $route.params.receiptNo }}</h5>
    </div>
    <table class="table mt-1 mx-1">
        <thead class="text-sm border-t-2 border-b-2 border-gray-400">
            <tr>
                <th class="p-tiny">Bill NO</th>
                <th class="p-tiny">Item</th>
                <th class="p-tiny">Qty</th>
                <th class="p-tiny">Amount</th>
                <th class="p-tiny">Memo</th>
            </tr>
        </thead>
        <tbody class="text-xs">
            <tr v-for="(item,idx) in items.receiptdetails" :key="idx" class="border-b border-gray-400">
                <td class="p-tiny">{{ item.billNo }}</td>
                <td class="p-tiny">{{ item.item }}</td>
                <td class="p-tiny">{{ item.qty }}</td>
                <td class="p-tiny">{{ item.paid | numberFormat }}</td>
                <td class="p-tiny">{{ item.refNo }}</td>
            </tr>
            <tr>
                <td colspan="5" class="p-1 text-right">
                    Total: {{ total | numberFormat }}
                </td>
            </tr>
        </tbody>
    </table>
     <table class="table mt-1 mx-1" v-if="items.consumablesdetails.length">
        <thead class="text-sm border-t-2 border-b-2 border-gray-400">
            <tr>
                <th class="p-tiny">#</th>
                <th class="p-tiny">Item</th>
                <th class="p-tiny">Qty</th>
                 <th class="p-tiny">Memo</th>
            </tr>
        </thead>
        <tbody class="text-xs">
            <tr v-for="(item,idx) in items.consumablesdetails" :key="idx" class="border-b border-gray-400">
                <td class="p-tiny">{{ item.id }} </td>
                <td class="p-tiny">{{ item.itemName }}</td>
                <td class="p-tiny">{{ item.quantity }}</td>
                 <td class="p-tiny">{{ item.description }}</td>
            </tr>
             
        </tbody>
    </table>
    <div class="w-full my-1 text-right mx-1">
        <h5 class="text-sm">Served By: {{ items.receiptdetails.length ? items.receiptdetails[0].userName : `` }}</h5>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-medium text-sm italic">{{ footerMessage.message }}</h5>
    </div>
</div>
</template>
